import {
  Box,
  Container,
  Flex,
  SimpleGrid,
  Stack,
  Stat,
  StatLabel,
  StatNumber,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Td,
  Text,
} from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { useFetchBoardProjectDetailQuery } from '../../api';
import {
  AppLink,
  CurrencyLabel,
  LoadingSkeleton,
  PageBody,
  PageCard,
  PageHeader,
} from '../components';
import { PaginatedTable } from '../components/PaginatedTable';

export interface BoardProjectDetailPageProps {}

export const BoardProjectDetail = (props: BoardProjectDetailPageProps) => {
  const { id: sId } = useParams();
  const id = sId ?? "0";
  const { data: bp } = useFetchBoardProjectDetailQuery(id, { skip: !id });

  return (
    <Box>
      <LoadingSkeleton isLoaded={!!bp}>
        <Stack spacing="8">
          <PageHeader
            title={`Board Project: ${bp?.name}`}
            subTitle={bp?.description}
          ></PageHeader>
          <Box as="section">
            <Container>
              <SimpleGrid columns={{ base: 1, md: 3 }} gap={{ base: 5, md: 6 }}>
                <PageCard>
                  <Stat>
                    <StatLabel noOfLines={1}>Board Approval</StatLabel>
                    <StatNumber>
                      <CurrencyLabel value={bp?.boardApproval} />
                    </StatNumber>
                  </Stat>
                </PageCard>
                <PageCard>
                  <Stat>
                    <StatLabel noOfLines={1}>Allocation</StatLabel>
                    <StatNumber>
                      <Flex>
                        <CurrencyLabel
                          value={bp?.allocatedBoardApproval}
                          flex={1}
                        />
                        <Text textAlign={'right'} as="i" pl={4}>
                          ({`${bp?.allocatedPercent}%`})
                        </Text>
                      </Flex>
                    </StatNumber>
                  </Stat>
                </PageCard>
                <PageCard>
                  <Stat>
                    <StatLabel>Budgeted:</StatLabel>
                    <StatNumber>
                      {/* <CurrencyLabel value={bp?.budgeted} /> */}
                      <Text>N/A</Text>
                    </StatNumber>
                  </Stat>
                </PageCard>
              </SimpleGrid>
            </Container>
          </Box>
          <PageBody>
            <Tabs>
              <TabList>
                <Tab>Allocations</Tab>
                <Tab>Dates</Tab>
              </TabList>
              <TabPanels>
                {/* Allocations  */}
                <TabPanel>
                  <PaginatedTable
                    items={bp?.allocations}
                    columns={[
                      {
                        sortKey: 'afeName',
                        component: 'AFE',
                      },
                      {
                        sortKey: 'amountPercent',
                        component: 'Amount %',
                      },
                      {
                        sortKey: 'boardApproval',
                        component: 'Board Approval',
                        isNumeric: true,
                      },
                      {
                        sortKey: 'afeBudget',
                        component: 'AFE Budget',
                        isNumeric: true,
                      },
                      {
                        sortKey: 'amount',
                        component: 'Amount Allocated',
                        isNumeric: true,
                      },
                      {
                        sortKey: 'room',
                        component: 'Available',
                        isNumeric: true,
                      },
                    ]}
                  >
                    {(row, i) => (
                      <>
                        <Td>
                          <AppLink to={`/afes/${row.afeId}/details`}>
                            ${row.afeName}
                          </AppLink>
                        </Td>
                        <Td>{row.amountPercent}%</Td>
                        <Td>
                          <CurrencyLabel value={row.boardApproval} />
                        </Td>
                        <Td>
                          <CurrencyLabel value={row.afeBudget} />
                        </Td>
                        <Td>
                          <CurrencyLabel value={row.amount} />
                        </Td>
                        <Td>
                          <CurrencyLabel value={row.room} />
                        </Td>
                      </>
                    )}
                  </PaginatedTable>
                </TabPanel>
                {/* <TabPanel>
                  <DateStack
                    dates={[
                      { label: 'Created', value: bp?.createdAt },
                      { label: 'Last Updated', value: bp?.updatedAt },
                    ]}
                  />
                </TabPanel> */}
              </TabPanels>
            </Tabs>
          </PageBody>
        </Stack>
      </LoadingSkeleton>
    </Box>
  );
};
